module.exports = __webpack_public_path__ + "static/media/deskopAppsLogo.716c639a.svg";